import { render, staticRenderFns } from "./SignInOIDCError.vue?vue&type=template&id=36dd8353&"
import script from "./SignInOIDCError.vue?vue&type=script&lang=ts&"
export * from "./SignInOIDCError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports